import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";
import { ArrowLeft, Printer } from "lucide-react";

// 18-B2 item 7: print-styled quarterly summary for a team (employer teams'
// headline artefact). Reuses the certificate print pattern.
export default function TeamQuarterly() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.teamQuarterly(id).then(setData).catch((e) =>
      setErr(e?.response?.data?.detail || "Could not load the summary"));
  }, [id]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-20 text-neutral-500">{err}</div>;
  if (!data) return <div className="max-w-3xl mx-auto px-6 py-20 text-neutral-500">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto px-6 py-10" data-testid="team-quarterly-page">
      <Seo title={`${data.team_name} — quarterly summary`} />
      <div className="no-print flex items-center justify-between gap-3 flex-wrap">
        <Link to="/teams" className="text-sm text-neutral-500 hover:text-forest inline-flex items-center gap-1.5">
          <ArrowLeft className="w-4 h-4" /> Back to teams
        </Link>
        <Button data-testid="quarterly-print-btn" onClick={() => window.print()} className="rounded-full bg-forest hover:bg-forest-hover">
          <Printer className="w-4 h-4 mr-2" /> Print
        </Button>
      </div>

      <div className="certificate-print mt-6 bg-white border-[6px] border-double border-forest rounded-2xl p-10 text-center" data-testid="quarterly-sheet">
        <div className="text-[10px] uppercase tracking-[0.3em] text-terracotta font-bold">CivicHearth quarterly summary</div>
        <h1 className="font-display text-3xl text-forest mt-3 tracking-tight" data-testid="quarterly-headline">
          Your team gave {data.person_hours} hours to {data.borough} this quarter
        </h1>
        <div className="text-sm text-neutral-500 mt-2">{data.team_name} — {data.quarter}</div>
        <div className="grid grid-cols-3 gap-4 mt-8">
          <div>
            <div className="font-display text-3xl text-forest" data-testid="quarterly-hours">{data.person_hours}</div>
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-1">Person-hours</div>
          </div>
          <div>
            <div className="font-display text-3xl text-forest" data-testid="quarterly-actions">{data.actions}</div>
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-1">Actions</div>
          </div>
          <div>
            <div className="font-display text-3xl text-forest" data-testid="quarterly-causes">{data.distinct_causes}</div>
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mt-1">Causes</div>
          </div>
        </div>
        {data.causes.length > 0 && (
          <div className="text-xs text-neutral-500 mt-6">
            Causes supported: {data.causes.join(" · ")}
          </div>
        )}
        <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-400 mt-10">
          Civic<span className="text-terracotta">.</span>Hearth — volunteer locally, ripple globally
        </div>
      </div>
    </div>
  );
}
